/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Mode_LabelInputs */



/**
* | output |
* | --- |
* | "Assistant mode" |
*
* @param {Assistant_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_mode_label = /** @type {((inputs?: Assistant_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Mode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode assistant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Assistentenmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità assistente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("режим помощника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo asistente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("助手模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アシスタントモード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहायक मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo assistente")
	return /** @type {LocalizedString} */ ("Assistant mode")
});